import React from 'react';
import PropTypes from 'prop-types';
import ButtonBase from '@/components/ButtonBase';
import cx from '@/utils/cx';
import LoadingBalls from '@/components/LoadingBalls';
import useStyle from './style';

const Button = ({
  children,
  _color,
  invert,
  outline,
  fill,
  _size = 'md',
  disabled,
  fullWidth,
  fab,
  className,
  loading,
  ...rest
}) => {
  const classes = useStyle({
    _color, invert, outline, _size, fullWidth, fab, fill,
  });
  return (
    <ButtonBase
      className={cx(
        classes.button,
        className,
        loading && 'loading',
      )}
      _size={_size}
      fixedWidth={fab}
      fullWidth={fullWidth}
      disabled={disabled}
      {...rest}
    >
      {children}
      {loading && <LoadingBalls className={classes.loading} _color={invert ? _color : 'background'} width={50} />}
    </ButtonBase>
  );
};

Button.propTypes = {
  /** One of keys that passed to ThemeProvider as colors */
  _color: PropTypes.string,
  outline: PropTypes.bool,
  fill: PropTypes.bool,
  invert: PropTypes.bool,
  disabled: PropTypes.bool,
  fab: PropTypes.bool,
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
};

Button.defaultProps = {
  _color: 'primary',
  outline: false,
  fill: true,
  invert: false,
  disabled: false,
  fab: false,
  fullWidth: false,
  loading: false,
};

export default Button;
